<template>
  <v-sheet
    class="permission-alert"
    color="white"
    elevation="4"
    height="100"
  >
    {{ message }}
  </v-sheet>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
.permission-alert {
  color: #AD1C3F !important;
  font-size: 24px;
  padding: 10px;
  margin: 10px;
}
</style>
